module.exports = __webpack_public_path__ + "img/13-2.73fea6a0.png";